import { Link } from "react-router-dom";
import "./Sidebar.scss";
import dashboard from "../../assets/images/Dashboard.svg";
import chevron from "../../assets/images/chevron.svg";
import Slide from "@mui/material/Slide";
import {
  getActiveTab,
  getSidebarStatus,
  setSidebarShow,
} from "../../store/slices/layout-slice";
import { useAppDispatch, useAppSelector } from "../../hooks/app";
import { MAIN_TABS } from "../../constants";
import LogBookLinks from "./LogBookLinks";
import TrainingLinks from "./TrainingLinks";
import useWindowSize from "../../hooks/useWindowSize";
import { useEffect, useState } from "react"
import AdminLinks from "./AdminLinks";

function Sidebar() {
  const activeTab = useAppSelector(getActiveTab);
  const sidebarStatus = useAppSelector(getSidebarStatus);
  const dispatch = useAppDispatch();
  const windowSize = useWindowSize()
  const [showSideBar, setShowSidebar] = useState(false)

  useEffect(() => {

    if (activeTab?.value === MAIN_TABS.REPORTS || activeTab?.value===MAIN_TABS.PROFILE || activeTab?.value===MAIN_TABS.FORBIDDEN ) {
      setShowSidebar(false)
    } else {
      setShowSidebar(true)
    }

  }, [activeTab])
  useEffect(() => {
    if (windowSize.width >= 700 && windowSize.width <= 900) {
      dispatch(setSidebarShow(false))
    }
    if (windowSize.width > 900) {
      dispatch(setSidebarShow(true))
    }
  }, [windowSize])
  return (
    <>
      {showSideBar && <div
        style={{ background: " #08192B" }}
        className={`side_menu ${sidebarStatus ? "active" : ""}`}
      >
        <h4 className="heading5 logbook_heading">
          <span>LOGBOOK </span>

          <img
            src={chevron}
            alt="Chevron Icon"
            onClick={() => dispatch(setSidebarShow(!sidebarStatus))}
          />
        </h4>
        <ul className="main_menu">
         
          {activeTab?.value === MAIN_TABS.LOG_BOOK && <LogBookLinks />}
          {activeTab?.value === MAIN_TABS.TRAINING && <TrainingLinks />}
          {activeTab?.value===MAIN_TABS.ADMIN && <AdminLinks/>}
        </ul>
      </div>}
    </>
  );
}

export default Sidebar;
